// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-expansion-panel[data-v-9644b4a2]:before{box-shadow:none!important}.v-expansion-panel-header[data-v-9644b4a2]{font-size:18px!important}.fixed[data-v-9644b4a2]{width:calc(100% - 140px);z-index:4!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
